import { GetHealthCheckData, SendUserToIdp } from 'api/security-endpoint';
import AppHeader from 'components/app-header';
import { useEffect, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { isUserLoggedIn } from 'utilities/AuthService';
import { Typography } from '@mui/material';
import { EXECUTIONS } from 'navigator/links';

function LoginPage(): JSX.Element {
  const isLoggedIn = isUserLoggedIn();
  const location = useLocation();
  const navigate = useNavigate();
  const queryParams = new URLSearchParams(location.search);
  const message = queryParams.get('message');
  const loginButtonRef = useRef<HTMLButtonElement>(null);

  useEffect(() => {
    if (loginButtonRef.current) {
      loginButtonRef.current.focus();
    }
    if (isLoggedIn) {
      navigate(EXECUTIONS);
    } else {
      if (!message) {
        try {
          // try to automatically redirect user to idp
          // can't do this because of SSO setup
          // SendUserToIdp()
        } catch {}
      }
    }
  }, []);

  const makeHealthCheck = async () => { 
    const response = await GetHealthCheckData();
    console.debug(response)
  }

  useEffect(() => {
    makeHealthCheck();
  }, []);

  return (
    <div className='main_root'>
      <AppHeader />
      <div className='main_content'>
        <div className='main_center-page-content-panel'>
          <button onClick={SendUserToIdp} ref={loginButtonRef} className='main_go-to-idp-button'>
            Log In with KSDE
          </button>
          {message && (
            <Typography variant='subtitle2' style={{ marginTop: '2rem' }}>
              {message}
            </Typography>
          )}
        </div>
      </div>
    </div>
  );
}

export default LoginPage;
